module.exports = __webpack_public_path__ + "346a309ab0f815549eb5d3bb38f4a6e4.MP3";